<template>
  <div class="attendance-container">
    <div class="attendance-content-outer">
      <div class="attendance-content-title">
        <p>Teachers Attendance</p>

        <!-- <div class="attendance-content-filter">
           <field :label="'Filter by'">
              <control :options="filterType" v-model="filter.filter_type" />
            </field>

            <field v-if="filter.filter_type == 'date'" :label="'Date Range'">
              <Datepicker v-model="filter.date_range" range :auto-apply="true" />
            </field>

            <field :label="''">
              <jb-button label="Search" color="info" :icon="mdiMagnify" small @click="getData()" />
            </field>
        </div> -->
      </div>

      <div class="attendance-header-container">
        <div class="attendance-header">
          <!-- <p>Today</p> -->
          <!-- <p>{{ formatMode(attendanceShow?.mode) }}</p> -->
          <p>{{ formattedMode }}</p>
          <p>{{ attendanceSummary?.data?.attendance_percentage }} %</p>
          <!-- <p>{{ attendanceSummary?.today?.data?.total_employee_presence }} / {{ attendanceSummary?.today?.data?.total_employee }}</p> -->
          <!-- <p v-if="attendanceShow?.mode === 'today'">{{ attendanceSummary?.today?.data?.total_employee_presence }} / {{ attendanceSummary?.today?.data?.total_employee }}</p> -->
          <p v-if="(attendanceShow?.mode === 'today') || (attendanceFilter.start_date == attendanceFilter.end_date)">{{ attendanceSummary?.data?.total_employee_presence }} / {{ attendanceSummary?.data?.total_employee }}</p>
          <p>Teachers Present</p>
          <p v-if="(attendanceShow?.mode === 'today')">{{ formatDate(attendanceFilter.start_date) }}</p>
          <p v-if="attendanceFilter.filter_type == 'date'">{{ formatDate(attendanceFilter.start_date, attendanceFilter.end_date) }}</p>
        </div>

        <table class="attendance-details">
          <tr @click="(attendanceEmployee?.leave?.total != 0) ? openDetailList('absent', attendanceEmployee?.leave) : null">
            <td>Leave</td>
            <td>{{ attendanceEmployee?.leave?.total }}</td>
            <td>{{ (attendanceEmployee?.leave?.total > 1) ? 'Employees' : 'Employee' }}</td>
          </tr>

          <tr @click="(attendanceEmployee?.permission?.total != 0) ? openDetailList('permission', attendanceEmployee?.permission) : null">
            <td>Permission</td>
            <td>{{ attendanceEmployee?.permission?.total }}</td>
            <td>{{ (attendanceEmployee?.permission?.total > 1) ? 'Employees' : 'Employee' }}</td>
          </tr>

          <tr @click="(attendanceEmployee?.sick?.total != 0) ? openDetailList('sick', attendanceEmployee?.sick) : null">
            <td>Sick</td>
            <td>{{ attendanceEmployee?.sick?.total }}</td>
            <td>{{ (attendanceEmployee?.sick?.total > 1) ? 'Employees' : 'Employee' }}</td>
          </tr>

          <tr @click="(attendanceEmployee?.absent?.total != 0) ? openDetailList('absent', attendanceEmployee?.absent) : null">
            <td>Absent</td>
            <td>{{ attendanceEmployee?.absent?.total }}</td>
            <td>{{ (attendanceEmployee?.absent?.total > 1) ? 'Employees' : 'Employee' }}</td>
          </tr>
        </table>
      </div>
    </div>

    <div v-if="!dataLoad" class="attendance-container-group">
      <div v-if="showWeekly" class="attendance-content-group">
        <p>Weekly</p>
        <p>{{ attendanceSummary?.weekly?.attendance_percentage }} %</p>
        <!-- <p>{{ formatDate(attendanceSummary?.weekly?.permission?.start_date, attendanceSummary?.weekly?.permission?.end_date) }}</p> -->
      </div>

      <div v-if="showMonthly" class="attendance-content-group">
        <p>Monthly</p>
        <p>{{ attendanceSummary?.monthly?.attendance_percentage }} %</p>
        <!-- <p>{{ formatDate(attendanceSummary?.monthly?.permission?.start_date, attendanceSummary?.monthly?.permission?.end_date) }}</p> -->
      </div>

      <div v-for="data in attendanceSummary?.semester" :key="data" class="attendance-content-group">
        <p>{{ data?.name }}</p>
        <p>{{ data?.attendance_percentage }} %</p>
        <!-- <p>{{ formatDate(data?.start_date, data?.end_date) }}</p> -->
      </div>
    </div>

    <div v-else class="attendance-container-group">
      <div v-for="data in 4" :key="data" class="attendance-content-group attendance-content-group-load" />
    </div>
  </div>

  <vue-final-modal
    v-model="modalDetailList" classes="flex justify-center items-center py-10 px-4" content-class="w-full max-w-md h-auto"
    :ssr="true" :lock-scroll="true" :hide-overlay="false" :click-to-close="false" :esc-to-close="true" :prevent-click="true" :attach="false" transition="vfm" overlay-transition="vfm" :z-index-auto="true" :z-index-base="1000" :z-index="false" :focus-retain="true" :focus-trap="false"
    :fit-parent="true" :drag="false" drag-selector="" :keep-changed-style="false" :resize="false" :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']" :min-width="250" :min-height="250" :max-width="Infinity" :max-height="Infinity"
  >
    <div class="modal-head pt-5 pb-5">
      <h1>{{ (detailType == 'permission') ? 'Permission' : (detailType == 'sick') ? 'Sick' : (detailType == 'absent') ? 'Absent' : (detailType == 'leave') ? 'Leave' : '' }}</h1>
      <jb-button class="btn-close-modal" :icon="mdiClose" @click="openDetailList()" />
    </div>

    <div class="modal-all-event">
      <div v-if="dataDetailList?.employee" class="all-event-container">
        <div v-for="data in dataDetailList?.employee" :key="data" class="all-event-list">
          <p v-html="data.name" />
          <p v-html="data.ein" />
          <p v-html="dateFormat(data.date)" />
        </div>
      </div>
    </div>
  </vue-final-modal>
</template>

<script>
  /* eslint-disable */
  import { ref, reactive, onMounted, onUnmounted, watch, watchEffect, computed, nextTick } from 'vue'
  import { mdiClose } from '@mdi/js'
  import { useToast } from 'vue-toastification'
  import { useI18n } from 'vue-i18n'
  import { AgGridVue } from 'ag-grid-vue3'
  import axios from 'axios'
  import Datepicker from "@vuepic/vue-datepicker"
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  import dayjs from 'dayjs'
  import isoWeek from "dayjs/plugin/isoWeek"
  import 'dayjs/locale/id'

  import Icon from "@/components/Icon"
  import Field from '@/components/Field'
  import Control from '@/components/Control'
  import JbButton from '@/components/JbButton'

  export default {
    components: {
      Icon,
      Field,
      Control,
      JbButton,
      Datepicker
    },

    props: {
      dataLoad: {type: Boolean, default: false},
      attendanceSummary: {type: Object, default: () => ({})},
      attendanceFilter: {type: Object, default: () => ({})},
      filterTeacherAttendance: {type: Object, default: () => ({})},
      teacherAttendanceData: {type: Object, default: () => ({})},
      teacherAttendanceSick: {type: Object, default: () => ({})},
      teacherAttendancePermission: {type: Object, default: () => ({})},
      teacherAttendanceAbsent: {type: Object, default: () => ({})},
      teacherAttendanceLeave: {type: Object, default: () => ({})},
      filterParams: {type: Object, default: () => ({})},
      attendanceEmployee: {type: Object, default: () => ({})},
    },

    setup (props, { emit }) {
      const attendanceShow = computed(() => props.attendanceFilter)

      // watchEffect(() => {
      //   if(props.attendanceSummary) {
      //     console.log("cek employee attendance", props.attendanceSummary)
      //   }
      // })


      dayjs.locale('id')
      const dateFormat = (date1, date2 = null) => {
        const d1 = dayjs(date1)
        const d2 = date2 ? dayjs(date2) : null

        if (!d1.isValid()) return ''

        if (!d2 || !d2.isValid()) {
          return d1.format('D MMMM YYYY')
        }

        if (d1.isSame(d2, 'day')) {
          return d1.format('D MMMM YYYY')
        }

        const sameMonth = d1.isSame(d2, 'month')
        const sameYear = d1.isSame(d2, 'year')

        if (sameMonth && sameYear) {
          return `${d1.format('D')}-${d2.format('D MMMM YYYY')}`
        }

        if (!sameMonth && sameYear) {
          return `${d1.format('D MMM')} - ${d2.format('D MMM YYYY')}`
        }

        return `${d1.format('D MMM YYYY')} - ${d2.format('D MMM YYYY')}`
      }


      dayjs.extend(isoWeek)

      const isWeeklyRange = computed(() => {
        if (attendanceShow.value?.mode !== "date_range") return false

        const start = dayjs(props.attendanceFilter.start_date)
        const end = dayjs(props.attendanceFilter.end_date)

        return (
          start.isoWeek() === end.isoWeek() &&
          start.year() === end.year()
        )
      })

      const isMonthlyRange = computed(() => {
        if (attendanceShow.value?.mode !== "date_range") return false

        const start = dayjs(props.attendanceFilter.start_date)
        const end = dayjs(props.attendanceFilter.end_date)

        return (
          start.month() === end.month() &&
          start.year() === end.year()
        )
      })

      const showWeekly = computed(() => {
        return attendanceShow.value?.mode === "today" || isWeeklyRange.value
      })

      const showMonthly = computed(() => {
        return attendanceShow.value?.mode === "today" || isMonthlyRange.value
      })


      const filter = reactive({
        filter_type: "today",
        start_date: "",
        end_date: "",
        date_range: []
      })
      const filterType = ref([
        {
          id: "today",
          label: "Today"
        },
        {
          id: "date",
          label: "Date Range"
        },
      ])

      // dayjs.locale('id')
      dayjs.locale('en')

      const formatDate = (startDate, endDate = null) => {
        if (!startDate) return ''

        const start = dayjs(startDate)

        if (!endDate) {
          return start.format('dddd, D MMMM YYYY')
        }

        const end = dayjs(endDate)

        if (start.isSame(end, 'day')) {
          return start.format('dddd, D MMMM YYYY')
        }

        const sameYear = start.year() === end.year()
        const sameMonth = start.month() === end.month() && sameYear

        if (sameMonth) {
          return `${start.format('D')}-${end.format('D MMMM YYYY')}`
        }

        if (sameYear) {
          return `${start.format('D MMMM')} - ${end.format('D MMMM YYYY')}`
        }

        return `${start.format('D MMMM YYYY')} - ${end.format('D MMMM YYYY')}`
      }

      // const formatMode = (mode) => {
      //   const modeMap = {
      //     'single_day'    : formatDate(attendanceShow?.start_date),
      //     'date_range'    : formatDate(attendanceShow?.start_date, attendanceShow?.end_date),
      //     'month'         : 'Month',
      //     'academic_year' : 'Academic Year' + ' ' + attendanceShow?.academic_year,
      //     'today'         : 'Today',
      //   }

      //   return modeMap[mode] ?? mode ?? '-'
      // }

      const formattedMode = computed(() => {
        const filter = props.attendanceFilter

        if (!filter || Object.keys(filter).length === 0) return ''

        const modeMap = {
          'single_day'    : formatDate(filter?.start_date),
          'date_range'    : formatDate(filter?.start_date, filter?.end_date),
          'month'         : 'Month',
          'academic_year' : 'Academic Year ' + (filter?.academic_year ?? ''),
          'today'         : 'Today',
        }

        return modeMap[filter?.mode] ?? formatDate(filter?.start_date) ?? '-'
      })


      const detailType = ref("")
      const dataDetailList = ref({})
      const modalDetailList = ref(false)
      const openDetailList = (type, data) => {
        if(data) {
          detailType.value = type
          dataDetailList.value = data
          modalDetailList.value = true
        }
        else {
          modalDetailList.value = false
          detailType.value = ""
          dataDetailList.value = ({})
        }
      }


      return {
        mdiClose,
        attendanceShow,
        dateFormat,
        filter,
        filterType,
        formatDate,
        formattedMode,
        detailType,
        dataDetailList,
        modalDetailList,
        openDetailList,
        isWeeklyRange,
        isMonthlyRange,
        showWeekly,
        showMonthly
      }
    }
  }
</script>

<style lang="scss">
  .attendance-container {
    .attendance-content-outer {
      width: 100%;
      height: auto;
      background-color: white;
      box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
      padding: 20px;

      .attendance-content-title {
        width: 100%;
        height: auto;
        padding: 0 0 16px 0;
        border-bottom: 1px solid lightgray;
        margin-bottom: 16px;

        p {
          font-size: 18px;
          line-height: 26px;
          font-weight: 600;
        }

        .attendance-content-filter {
          width: 100%;
          height: auto;
          display: flex;
          flex-direction: row;
          align-items: end;
          gap: 8px;
          margin-top: 16px;

          .general-filter-content {
            width: calc((100% - 106px) / 2);

            p {
              font-size: 12px;
              line-height: 18px;
            }

            select, input {
              border: 1px solid lightgray !important;
              font-size: 14px;
              line-height: 20px;
              border-radius: 0;
              padding: 8px 12px !important;
              height: 42px !important;
            }

            .btn-univ {
              padding: 6px 16px;

              span {
                font-size: 14px;
                line-height: 20px;
              }
            }

            &:nth-last-child(1) {
              width: 42px;
            }
          }
        }
      }

      .attendance-header-container {
        width: 100%;
        height: auto;

        .attendance-header {
          width: 100%;
          position: relative;

          p {
            width: 100%;
            text-align: center;
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;

            &:nth-child(2) {
              font-size: 40px;
              line-height: 60px;
              font-weight: 700;
              color: blue;
            }
          }
        }

        table.attendance-details {
          width: 100%;

          tr {
            td {
              font-size: 14px;
              line-height: 20px;
              padding: 8px 0;
              font-weight: 500;
              cursor: pointer;
              transition: background-color .3s;

              &:nth-child(1) {
                width: 100px;
              }

              &:nth-child(2) {
                text-align: right;
                padding-right: 8px;
                font-weight: 600;
              }

              &:nth-child(3) {
                width: 80px;
              }
            }

            &:hover {
              td {
                background-color: whitesmoke;
              }
            }

            &:nth-child(1) {
              td {
                color: blue;
              }
            }

            &:nth-child(2) {
              td {
                color: green;
              }
            }

            &:nth-child(3) {
              td {
                color: orangered;
              }
            }

            &:nth-child(4) {
              td {
                color: red;
              }
            }
          }
        }
      }
    }

    .attendance-container-group {
      width: 100%;
      height: auto;
      display: flex;
      flex-wrap: wrap;
      gap: 20px;
      margin-top: 20px;
      justify-content: center;

      .attendance-content-group {
        width: 100%;
        height: auto;
        background-color: #e4ecff;
        padding: 16px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        p {
          width: 100%;
          text-align: center;
          font-size: 14px;
          font-weight: 600;

          &:nth-child(2) {
            font-size: 40px;
            line-height: 60px;
            font-weight: 700;
            color: blue;
          }
        }
      }

      .skeleton {
        position: relative;
        overflow: hidden;
        background-color: #e3e3e3;

        &::after {
          content: "";
          position: absolute;
          inset: 0;
          transform: translateX(-100%);
          background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.5) 50%,
            rgba(255, 255, 255, 0) 100%
          );
          animation: shimmer 1.4s infinite;
        }
      }

      .attendance-content-group-load {
        @extend .skeleton;
        height: 140px;
      }

      @keyframes shimmer {
        100% {
          transform: translateX(100%);
        }
      }
    }
  }
</style>
